import React, { useState } from "react"
import { createPortal } from "react-dom"
import { ONE_WAY_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import { reportListData } from "Pages/ReportsAlerts/Reports/@signals"
import ReportsOneWaysPageContent from "Pages/ReportsAlerts/Reports/OneWays/Page"
import VirtualTourButton, { TourOverlay, TOUR_STEPS } from "./VirtualTour"
import ReportsDemoData from "Pages/ReportsAlerts/Reports/Common/VirtualTour/DemoData"

export default function OneWaysReports() {
	const [tourActive, setTourActive] = useState(false)
	const showDemoData = tourActive && !reportListData.value?.length

	return <PageWrapper
		head={`DS Rentacar | ${ONE_WAY_ROUTES.REPORTS_TITLE}`}
		title={ONE_WAY_ROUTES.REPORTS_TITLE}
		isEmpty={false}
		// the icons legend sits under the table, as in the other report lists
		actions={<VirtualTourButton onClick={() => setTourActive(true)} />}
	>
		<ReportsOneWaysPageContent hideCrudTable={showDemoData}/>
		{showDemoData && <ReportsDemoData/>}
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => setTourActive(false)} />,
			document.body
		)}
	</PageWrapper>
}
